import { render, staticRenderFns } from "./EmployeeBrandingEdit.vue?vue&type=template&id=0d8a6820&scoped=true&"
import script from "./EmployeeBrandingEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeeBrandingEdit.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeBrandingEdit.vue?vue&type=style&index=0&id=0d8a6820&scoped=true&lang=css&"
import style1 from "./EmployeeBrandingEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a6820",
  null
  
)

export default component.exports